<template>

  <vx-card :title="$t('class-room.teacher-description')" class="mb-base p-1 " title-color="primary">
    <vs-avatar :src="getAvatarUrl(teacher.picturePath)"
               class="mx-auto mb-6 block"
               size="160px"
    />

    <template slot="actions">
      <div class="flex justify-end">
        <vs-button radius color="success" type="border" icon="keyboard_backspace"
                   @click="goBack">
        </vs-button>
      </div>
    </template>

    <div class="text-center">
      <h4>{{ teacher | teacherName }}</h4>
    </div>
    <template slot="footer">
      <vs-divider/>
      <div class="">

        <p class="flex" v-if="teacher.telephone">
          <feather-icon icon="PhoneIcon" svgClasses="h-5 w-5 text-primary stroke-current"/>
          <span class="ml-2">
          {{ teacher.telephone }}</span>
        </p>

        <p class="flex" v-if="teacher.email">
          <feather-icon icon="MailIcon" svgClasses="h-5 w-5 text-primary stroke-current"/>
          <span class="ml-2">
          {{ teacher.email }}</span>
        </p>

        <p class="flex" v-if="teacher.socialMedia">
          <feather-icon icon="SmartphoneIcon" svgClasses="h-5 w-5 text-primary stroke-current"/>
          <span class="ml-2">
          {{ teacher.socialMedia }}</span>
        </p>

        <p class="flex" v-if="teacher.availableTime">
          <feather-icon icon="ClockIcon" svgClasses="h-5 w-5 text-primary stroke-current"/>
          <span class="ml-2">
          {{ teacher.availableTime }}</span>
        </p>

      </div>
    </template>
  </vx-card>

</template>

<script>
  import {getAvatarUrl} from "@/utils/upload";

  export default {
    props: {
      classRoom: Object
    },
    computed: {
      teacher() {
        return this.classRoom ? this.classRoom.teacher : {};
      }
    },
    data() {
      return {
        getAvatarUrl: getAvatarUrl,
      }
    },
    methods:{
      goBack(){
        this.$router.go(-1);
      }
    }
  }
</script>

<style scoped>

</style>
